import { render, staticRenderFns } from "./lesson.vue?vue&type=template&id=2f24483e&"
import script from "./lesson.vue?vue&type=script&lang=js&"
export * from "./lesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports